<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrighta" id="copyright">PUBLISHER’S NOTE: This is a work of fiction. Names, characters, places, and incidents are either the product of the author’s imagination or used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Names: Soria, Destiny, author.<br/>Title: Beneath the citadel / by Destiny Soria.</p>
<p class="copyrighti">Description: New York: Amulet Books, 2018. | Summary: Cassa, the orphaned daughter of rebels, and friends Alys, Evander, and Newt, fight back against the high council of Eldra, which has ruled for centuries based solely on ancient prophesies.</p>
<p class="copyrighti">Identifiers: LCCN 2018001836 | ISBN 9781419731464 (hardcover with jacket) | eISBN 9781683353850</p>
<p class="copyrighti">Subjects: | CYAC: Prophecies—Fiction. | Revolutions—Fiction. | Orphans—Fiction. | Fantasy.</p>
<p class="copyrighti">Classification: LCC PZ7.1.S678 Be 2018 | DDC [Fic]—dc23</p>
<p class="copyright">Text copyright © 2018 Destiny Soria<br/>Jacket illustrations copyright © 2018 Bill Elis<br/>Jacket and book design by Siobhán Gallagher<br/>Jacket typography by Neil Swaab<br/>Jacket copyright © 2018 Amulet Books</p>
<p class="copyright">Published in 2018 by Amulet Books, an imprint of ABRAMS. All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.</p>
<p class="copyright">Amulet Books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use. Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.</p>
<p class="copyright">Amulet Books<sup>®</sup> is a registered trademark of Harry N. Abrams, Inc.</p>
<p class="pub"><img alt="Images" src="images/copy.jpg"/></p>
<p class="copyright0"><strong>ABRAMS</strong> The Art of Books<br/>195 Broadway, New York, NY 10007<br/><a href="http://abramsbooks.com" target="_blank">abramsbooks.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2d7c4659